var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-pic"},[_c('img',{attrs:{"src":_vm.getParticipantAvatar(_vm.username),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }